import { DECORATED_ERROR_CONTEXT_KEY } from './consts';
import type { ReportableErrorContext } from './types';

export function decorateErrorForReporting(error: Error, context: ReportableErrorContext): Error {
	if (!(error instanceof Error)) {
		return error;
	}

	// eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
	const existingContext = (error as any)[DECORATED_ERROR_CONTEXT_KEY] as ReportableErrorContext | undefined;
	if (existingContext) {
		Object.defineProperty(error, DECORATED_ERROR_CONTEXT_KEY, {
			value: {
				context: {
					...existingContext.context,
					...context.context,
				},
				params: {
					...existingContext.params,
					...context.params,
				},
			} satisfies ReportableErrorContext,
			configurable: true,
		});
	} else {
		Object.defineProperty(error, DECORATED_ERROR_CONTEXT_KEY, {
			value: context,
			configurable: true,
		});
	}

	return error;
}
